var map = {
	"./20220629_114210.jpg": 8826,
	"./20220818_200110.jpg": 2683,
	"./20220821_144348.jpg": 7907,
	"./20220824_153420.jpg": 2341,
	"./20220915_161250.jpg": 4996,
	"./20230103_132554.jpg": 4027,
	"./20230107_180943.jpg": 3158,
	"./20230615_151846.jpg": 7922,
	"./20230616_151042.jpg": 5251,
	"./20230622_161427.jpg": 7348,
	"./20230623_150441.jpg": 2331,
	"./20230729_134236.jpg": 7160,
	"./20230914_163138.jpg": 8223,
	"./20230929_154003.jpg": 7362,
	"./20231123_153402.jpg": 3337,
	"./20231207_142611.jpg": 3794,
	"./20240126_105413.jpg": 523,
	"./20240228_133154.jpg": 1415,
	"./20240228_141858.jpg": 9995,
	"./20240305_150344.jpg": 5663,
	"./20240313_152913.jpg": 3748,
	"./20240403_160253.jpg": 8574,
	"./20240403_162343.jpg": 378,
	"./20240405_154309.jpg": 3135,
	"./20240408_155441.jpg": 8344,
	"./20240531_131333.jpg": 5617,
	"./20240531_150631.jpg": 6931,
	"./IMG-20230127-WA0011.jpg": 799,
	"./IMG-20230128-WA0026.jpg": 3024,
	"./IMG-20230309-WA0059.jpg": 9985,
	"./IMG-20231123-WA0350.jpg": 6504,
	"./IMG-20240124-WA0031.jpg": 7613,
	"./IMG_20240210_225743_749.jpg": 2059,
	"./aboutus_cover.jpg": 9240,
	"./aboutus_cover1.jpg": 8735,
	"./cover-photo.jpg": 3433,
	"./gallerypic1.jpg": 8044,
	"./gallerypic2.jpg": 3211,
	"./gallerypic3.jpg": 3726,
	"./gallerypic4.jpg": 789,
	"./photo_2024-07-28_23-31-34.jpg": 9268,
	"./photo_2024-07-28_23-31-43.jpg": 7554,
	"./photo_2024-07-28_23-31-47.jpg": 2694,
	"./photo_2024-07-28_23-31-52.jpg": 9348,
	"./photo_2024-07-28_23-31-56.jpg": 672,
	"./photo_2024-07-28_23-32-00.jpg": 9848,
	"./photo_2024-07-28_23-32-04.jpg": 1308,
	"./photo_2024-07-28_23-32-08.jpg": 1680,
	"./photo_2024-07-28_23-32-12.jpg": 3701,
	"./photo_2024-07-28_23-32-16.jpg": 2937,
	"./photo_2024-07-28_23-32-19.jpg": 4226,
	"./photo_2024-08-20_21-57-49.jpg": 2885,
	"./photo_2024-08-20_21-57-53.jpg": 3504,
	"./photo_2024-08-20_21-57-57.jpg": 68,
	"./photo_2024-08-20_21-58-01.jpg": 8060,
	"./photo_2024-08-20_21-58-05.jpg": 9272,
	"./photo_2024-08-20_21-58-08.jpg": 8721,
	"./photo_2024-08-20_21-58-12.jpg": 1184,
	"./photo_2024-08-20_21-58-16.jpg": 276,
	"./photo_2024-08-20_21-58-20.jpg": 3031,
	"./photo_2024-08-20_21-58-24.jpg": 9019,
	"./photo_2024-08-20_21-58-27.jpg": 7036,
	"./photo_2024-08-20_21-58-31.jpg": 6789,
	"./photo_2024-08-20_21-58-35.jpg": 5401,
	"./photo_2024-08-20_21-58-42.jpg": 1623,
	"./photo_2024-08-20_21-58-46.jpg": 2456,
	"./photo_2024-08-20_21-58-50.jpg": 1310,
	"./photo_2024-08-20_21-58-53.jpg": 8425,
	"./photo_2024-08-20_21-58-57.jpg": 3781,
	"./photo_2024-09-24_20-39-07.jpg": 7747,
	"./photo_2024-09-24_20-39-11.jpg": 3986,
	"./photo_2024-09-24_20-39-16.jpg": 9473,
	"./photo_2024-09-24_20-39-18.jpg": 5847,
	"./photo_2024-09-24_20-39-21.jpg": 2855,
	"./photo_2024-09-24_20-39-25.jpg": 9963,
	"./photo_2024-09-24_20-39-31.jpg": 3428,
	"./photo_2024-12-15_22-25-29.jpg": 6396,
	"./photo_2024-12-15_22-25-43.jpg": 3244,
	"./photo_2024-12-15_22-26-06.jpg": 2596,
	"./photo_2024-12-15_22-26-09.jpg": 663,
	"./photo_2024-12-15_22-26-12.jpg": 6987,
	"./photo_2024-12-15_22-26-15.jpg": 5400,
	"./photo_2024-12-15_22-26-18.jpg": 2513,
	"./photo_2024-12-15_22-26-22.jpg": 3418,
	"./photo_2024-12-15_22-26-25.jpg": 4313,
	"./photo_2024-12-15_22-26-28.jpg": 3632,
	"./photo_2024-12-15_22-26-30.jpg": 7511,
	"./photo_2024-12-15_22-26-33.jpg": 3288,
	"./photo_2024-12-15_22-26-36.jpg": 4889,
	"./school_girl_standing.jpg": 2431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9968;